module.exports = __webpack_public_path__ + "img/shuixi10.4a877e56.png";